;(function() {
"use strict";

"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//events - a super-basic Javascript (publish subscribe) pattern

var EventDispatcher = function () {
	function EventDispatcher() {
		_classCallCheck(this, EventDispatcher);

		this.events = {};
	}

	// subscribe fn to event


	_createClass(EventDispatcher, [{
		key: "on",
		value: function on(eventName, fn) {
			this.events[eventName] ? this.events[eventName].push(fn) : this.events[eventName] = [fn];
		}

		// unsubscribe fn from event

	}, {
		key: "off",
		value: function off(eventName, fn) {
			if (fn == undefined) {
				// unsubscribe all
				this.events[eventName] = undefined;
				return;
			}

			var events = this.events[eventName];
			if (events) {
				var foundIndex = events.indexOf(fn);
				if (foundIndex !== -1) {
					events.splice(foundIndex, 1);
				}
			}
		}

		// fire off an event

	}, {
		key: "emit",
		value: function emit(eventName) {
			for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				data[_key - 1] = arguments[_key];
			}

			if (this.events[eventName]) {
				this.events[eventName].forEach(function (fn) {
					fn.apply(undefined, data);
				});
			}
		}
	}]);

	return EventDispatcher;
}();

var EventfulClass = function () {
	function EventfulClass() {
		var eventDispatcher = arguments.length <= 0 || arguments[0] === undefined ? new EventDispatcher() : arguments[0];

		_classCallCheck(this, EventfulClass);

		if (!(eventDispatcher instanceof EventDispatcher)) throw new TypeError("eventDispatcher must be an instance of EventDispatcher");
		this._dispatcher = eventDispatcher;
	}

	_createClass(EventfulClass, [{
		key: "on",
		value: function on() {
			var _dispatcher;

			(_dispatcher = this.dispatcher).on.apply(_dispatcher, arguments);
		}
	}, {
		key: "off",
		value: function off() {
			var _dispatcher2;

			(_dispatcher2 = this.dispatcher).off.apply(_dispatcher2, arguments);
		}
	}, {
		key: "emit",
		value: function emit() {
			var _dispatcher3;

			(_dispatcher3 = this.dispatcher).emit.apply(_dispatcher3, arguments);
		}
	}, {
		key: "dispatcher",
		get: function get() {
			return this._dispatcher;
		}
	}]);

	return EventfulClass;
}();

var eventDispatcher = new EventDispatcher();

// sound alarm on timer:session-changed

eventDispatcher.on('timer:session-changed', function (_ref) {
	var reason = _ref.reason;

	// don't fire on skipSession
	if (reason === "previous-session-ended" && checkVolume.checked) playSound(true);
});

// input[type="range"]#volume
var volumeSlider = document.getElementById("volume");

volumeSlider.oninput = function () {
	console.log("volume changed", this.value);
	eventDispatcher.emit("alarm-volume:set", audio.volume = this.value);
};

var fileUpload = document.getElementById("file-upload");
var resetUploadBtn = document.getElementById("reset-upload-btn");

function setCustomSoundValues() {
	resetUploadBtn.textContent = "Default sound";
	resetUploadBtn.value = "reset";
	panel.classList.remove("default-sound");
}

var defaultSound = "audio/alarm.mp3";
var audio = new Audio(defaultSound);
audio.volume = volumeSlider.value;
resetUploadBtn.addEventListener("click", function () {
	if (this.value === "upload") {
		// empty fileUpload.files
		fileUpload.value = "";
		fileUpload.click();
	} else {
		revertToDefault();
	}
});

function revertToDefault() {
	audio.src = defaultSound;
	speakerContainer.classList.remove("playing");
	console.log("audio state immediate", audio.paused, audio.currentTime);
	console.log("reverting to default");
	resetUploadBtn.textContent = "Custom sound";
	resetUploadBtn.value = "upload";
	panel.classList.add("default-sound");

	eventDispatcher.emit("alarm-sound:reset");
}

fileUpload.addEventListener("change", function () {
	console.log("upload change", this.files);
	if (this.files.length === 0) return;
	handleFile(this.files[0]);
	setCustomSoundValues();
});

var speakerSvg = document.getElementById("speakerSvg");
var speakerContainer = speakerSvg.parentElement;
speakerSvg.addEventListener("click", function () {
	return playSound();
});

function playSound() {
	var restart = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

	if (audio.error || !audio.src) return;
	console.log("AUDIO PAUSED", audio.paused);

	if (audio.paused) {
		audio.play();
	} else {
		// play from start if currently playing after being triggered by user
		if (!restart) audio.pause();
		audio.currentTime = 0;
	}
}

function handleFile(file) {
	console.log(file);
	var reader = new FileReader();
	reader.onload = function (e) {
		console.log("alarm-sound setting");
		eventDispatcher.emit("alarm-sound:set", audio.src = e.target.result);
		speakerContainer.classList.remove("playing");
	};
	reader.readAsDataURL(file);
}

audio.addEventListener("play", function () {
	console.log("play");
	speakerContainer.classList.add("playing");
	startSpeakerTremble();
});
audio.addEventListener("pause", function () {
	console.log("pause");
	speakerContainer.classList.remove("playing");
	stopSpeakerTremble();
});

audio.addEventListener("canplay", function () {
	console.log("canplay");
	speakerContainer.classList.remove("error");
	if (audio.paused) stopSpeakerTremble();
});
audio.addEventListener("error", function (e) {
	console.log("error", e, audio.error, "code", audio.error.code);
	speakerContainer.classList.add("error");
	stopSpeakerTremble();
});

// animate .speaker
var turbulence = document.getElementById("feTurbulence6680");
var speakerInner = document.getElementById("speakerInner");
function speakerTremble() {
	turbulence.seed.baseVal = (turbulence.seed.baseVal + 1) % 100;
	speakerInner.r.baseVal.value += speakerTremble.radCoeff * 0.5;
	if (speakerInner.r.baseVal.value > 25) speakerTremble.radCoeff = -1;else if (speakerInner.r.baseVal.value < 20) speakerTremble.radCoeff = 1;

	if (speakerTremble.on) requestAnimationFrame(speakerTremble);
}
speakerTremble.on = false;
speakerTremble.radCoeff = 1;
function startSpeakerTremble() {
	speakerTremble.on = true;
	turbulence.numOctaves.baseVal = 5;
	requestAnimationFrame(speakerTremble);
}
function stopSpeakerTremble() {
	speakerTremble.on = false;
	turbulence.numOctaves.baseVal = 0;
}

// drag & drop in .panel.audioControls
var panel = document.getElementById("speakerPanel");
/* events fired on the drop targets */
panel.addEventListener("dragover", function (e) {
	// prevent default to allow drop
	//console.log("dragover", e.target);
	e.stopPropagation();
	e.preventDefault();
});

panel.addEventListener("dragenter", function (e) {
	// indicate .panel as a .dropzone
	e.stopPropagation();
	e.preventDefault();
	//console.log("dragenter", e.target);
	panel.classList.add("dropzone");
});

panel.addEventListener("dragend", function (e) {
	e.stopPropagation();
	e.preventDefault();
	//console.log("dragend", e.target);
	panel.classList.remove("dropzone");
});

panel.addEventListener("dragleave", function (e) {
	e.stopPropagation();
	e.preventDefault();
	toggleDropzone(e);
});

panel.addEventListener("drop", function (e) {
	// prevent default action (open as link for some elements)
	e.stopPropagation();
	e.preventDefault();
	console.log("drop", e.target);
	panel.classList.remove("dropzone");

	var file = e.dataTransfer.files[0];
	if (file.type.indexOf("audio/") === 0) {
		handleFile(file);
		setCustomSoundValues();
	}
});

function toggleDropzone(e) {
	return panel.classList.toggle("dropzone", panel.contains(document.elementFromPoint(e.clientX, e.clientY)));
}

// .globalSettings > .pauseControls

var pauseOnBreakStart = document.getElementById("pause-on-break-start");
var pauseOnWorkStart = document.getElementById("pause-on-work-start");

pauseOnBreakStart.addEventListener('change', function () {
	console.log(this, "changed to", this.checked ? "checked" : "unchecked");
	eventDispatcher.emit('check-pause-on-break-start:changed', this.checked);
});
pauseOnWorkStart.addEventListener('change', function () {
	console.log(this, "changed to", this.checked ? "checked" : "unchecked");
	eventDispatcher.emit('check-pause-on-work-start:changed', this.checked);
});

// .globalSettings > .notificationControls

var notifyOnBreak = document.getElementById("notify-break");
var notifyOnWork = document.getElementById("notify-work");

notifyOnBreak.addEventListener('change', function () {
	console.log(this, "changed to", this.checked ? "checked" : "unchecked");
	eventDispatcher.emit('notify-break:changed', this.checked);
});
notifyOnWork.addEventListener('change', function () {
	console.log(this, "changed to", this.checked ? "checked" : "unchecked");
	eventDispatcher.emit('notify-work:changed', this.checked);
});

notifyOnBreak.onclick = notifyOnWork.onclick = askForPermission;

(function () {
	// if notifications aren't supported, remove the panel
	if (!("Notification" in window)) {
		// don't keep references
		notifyOnBreak = notifyOnWork = null;
		var notificationPanel = document.querySelector('.notificationControls');
		notificationPanel.parentNode.removeChild(notificationPanel);
	} else if (Notification.permission === 'denied') {
		disableNotifyChecks();
	}
})();

function askForPermission() {
	// if any notification checkbox is checked
	if (notifyOnBreak.checked || notifyOnWork.checked) testForNotification();
}

function disableNotifyChecks() {
	notifyOnBreak.disabled = notifyOnWork.disabled = true;
	notifyOnBreak.checked = notifyOnWork.checked = false;
}

function testForNotification() {
	// if already granted
	if (Notification.permission === "granted") return;

	// if permission wasn't denied previously
	if (Notification.permission !== 'denied') {
		// returns a Promise resolved with granted or denied, doesn't do anything on default (when dismissed)
		Notification.requestPermission().then(function (result) {
			if (result === "denied") {
				// ask only once
				notifyOnBreak.onclick = notifyOnWork.onclick = null;
				// if no permission, uncheck and disable
				disableNotifyChecks();
			} else if (result === "granted") {
				// ask only once
				notifyOnBreak.onclick = notifyOnWork.onclick = null;
			}
			// don't do anything === ask again later if(result === "default")
			console.log("NOTIFY REQUEST", result);
		});
	}
}

// keep reference to last notification
var notification = void 0;

// dismiss notfication if clicked anywhere on the page
document.addEventListener("click", function () {
	if (notification) notification.close();
});

function fireNotification(sessionName) {
	// if .notificationControls has been removed
	if (notifyOnBreak === null) return;
	// only if permission is granted explicitly
	if (Notification.permission !== "granted") return;

	var itsBreakTime = sessionName === "break";
	if (itsBreakTime && notifyOnBreak.checked || !itsBreakTime && notifyOnWork.checked) {
		notification = buildNotification(itsBreakTime);
		notification.onclose = function () {
			console.log("notification closed");
			// don't keep the reference
			notification = null;
		};
		notification.onclick = function () {
			console.log("notification clicked");
			window.focus();
			notification.close();
		};
		console.log(notification);
	}
}

var icon = "images/clock_red.png";

function buildNotification(itsBreakTime) {
	var title = itsBreakTime ? "Time for a Break" : "Time for Work";
	var body = itsBreakTime ? "Good work! Time for a break." : "Ready for more? Time for work.";

	console.log("FIRING NOTIFICATION");

	return new Notification(title, { body: body, icon: icon });
}

eventDispatcher.on('timer:session-changed', function (_ref2) {
	var name = _ref2.started.session.name;
	var reason = _ref2.reason;

	console.log("session started", name, "for reason", reason);
	// don't Notification fire on skipSession
	if (reason === "previous-session-ended") fireNotification(name);
});

// .pomodoroDefaults button

var work25 = document.getElementById('work-25');
var shortBreak5 = document.getElementById('short-break-5');
var longBreak15 = document.getElementById('long-break-15');
var longBreak30 = document.getElementById('long-break-30');

work25.addEventListener('click', function () {
	eventDispatcher.emit("work-timer:set", 25);
});
shortBreak5.addEventListener('click', function () {
	eventDispatcher.emit("break-timer:set", 5);
});
longBreak15.addEventListener('click', function () {
	eventDispatcher.emit("break-timer:set", 15);
});
longBreak30.addEventListener('click', function () {
	eventDispatcher.emit("break-timer:set", 30);
});

// button.plus and .minus in .timingControls > .workTimer and. breakTimer

var workPlus = document.querySelector('.workTimer > .plus');
var workMinus = document.querySelector('.workTimer > .minus');

var breakPlus = document.querySelector('.breakTimer > .plus');
var breakMinus = document.querySelector('.breakTimer > .minus');

var multiplier = 1;

document.addEventListener("keydown", function (e) {
	// keyCode 16 = SHIFT
	if (e.keyCode === 16) {
		console.log("SHIFT PRESSED");
		multiplier = 5;
	}
});
document.addEventListener("keyup", function (e) {
	if (e.keyCode === 16) {
		console.log("SHIFT RELEASED");
		multiplier = 1;
	}
});

function workIncrement() {
	eventDispatcher.emit('work-timer:++', multiplier);
}
function workDecrement() {
	eventDispatcher.emit('work-timer:--', multiplier);
}

function breakIncrement() {
	console.log("breakincr");
	eventDispatcher.emit('break-timer:++', multiplier);
}
function breakDecrement() {
	eventDispatcher.emit('break-timer:--', multiplier);
}

function repeatFunction(repeatF) {
	var freq = arguments.length <= 1 || arguments[1] === undefined ? 200 : arguments[1];

	var intervalId = void 0;
	function start() {
		repeatF();
		intervalId = setInterval(repeatF, freq);
	}
	function stop() {
		clearInterval(intervalId);
	}

	return { start: start, stop: stop };
}

function connectButtonOnOff(btn, _ref3) {
	var start = _ref3.start;
	var stop = _ref3.stop;

	btn.addEventListener('mousedown', start);
	btn.addEventListener('mouseup', stop);
	btn.addEventListener('mouseleave', stop);
}

var workIncrementRepeat = repeatFunction(workIncrement);
var workDecrementRepeat = repeatFunction(workDecrement);

var breakIncrementRepeat = repeatFunction(breakIncrement);
var breakDecrementRepeat = repeatFunction(breakDecrement);

connectButtonOnOff(workPlus, workIncrementRepeat);
connectButtonOnOff(workMinus, workDecrementRepeat);

connectButtonOnOff(breakPlus, breakIncrementRepeat);
connectButtonOnOff(breakMinus, breakDecrementRepeat);

function connectKeydown(btn, fn) {
	btn.addEventListener('keydown', function (e) {
		// keyCode 32 = space, 13 = Enter, 16 = Shift
		if (e.keyCode === 32 || e.keyCode === 13) {
			fn();
		}
	});
}

connectKeydown(workPlus, workIncrement);
connectKeydown(workMinus, workDecrement);

connectKeydown(breakPlus, breakIncrement);
connectKeydown(breakMinus, breakDecrement);

function disableBtn(disable, btnName) {
	if (btnName === "work") {
		work25.disabled = workMinus.disabled = workPlus.disabled = disable;

		// stop incr/decrementing if in progress
		workIncrementRepeat.stop();
		workDecrementRepeat.stop();
	} else if (btnName === "break") {
		longBreak30.disabled = longBreak15.disabled = shortBreak5.disabled = breakMinus.disabled = breakPlus.disabled = disable;

		// stop incr/decrementing if in progress
		breakIncrementRepeat.stop();
		breakDecrementRepeat.stop();
	}
}

eventDispatcher.on('timer:state-changed', function (_ref4) {
	var currentState = _ref4.currentState;
	var sessionName = _ref4.session.name;

	disableBtn(currentState === "active", sessionName);
});
eventDispatcher.on('timer:session-changed', function (_ref5) {
	var endedSessionName = _ref5.ended.session.name;
	var startedSessionName = _ref5.started.session.name;

	disableBtn(false, endedSessionName);
	disableBtn(true, startedSessionName);
});

// .time in .timingControls > .workTimer and .breakTimer

var workTime = document.querySelector('.workTimer > .time');
var breakTime = document.querySelector('.breakTimer > .time');

function getWorkTimeSetting() {
	return parseInt(workTime.textContent, 10);
}

function getBreakTimeSetting() {
	return parseInt(breakTime.textContent, 10);
}

function getValidTime(val) {
	return val < 1 ? 1 : val;
}

function emitControlTimerChange(timer, val) {
	// "work-timer:time-set" or "break-timer:time-set"
	eventDispatcher.emit(timer + "-timer:time-set", val * 60);
}

eventDispatcher.on('work-timer:++', function () {
	var multiplier = arguments.length <= 0 || arguments[0] === undefined ? 1 : arguments[0];

	var oldVal = parseInt(workTime.textContent, 10);
	var newVal = oldVal + 1 * multiplier;
	newVal = getValidTime(newVal);
	if (oldVal === newVal) return;
	workTime.textContent = newVal;

	emitControlTimerChange("work", newVal);
});
eventDispatcher.on('work-timer:--', function () {
	var multiplier = arguments.length <= 0 || arguments[0] === undefined ? 1 : arguments[0];

	var oldVal = parseInt(workTime.textContent, 10);
	var newVal = oldVal - 1 * multiplier;
	newVal = getValidTime(newVal);
	if (oldVal === newVal) return;
	workTime.textContent = newVal;

	emitControlTimerChange("work", newVal);
});
eventDispatcher.on('work-timer:set', function (minutes) {
	if (parseInt(workTime.textContent, 10) === minutes) return;
	workTime.textContent = minutes;

	emitControlTimerChange("work", minutes);
});

eventDispatcher.on('break-timer:++', function () {
	var multiplier = arguments.length <= 0 || arguments[0] === undefined ? 1 : arguments[0];

	var oldVal = parseInt(breakTime.textContent, 10);
	var newVal = oldVal + 1 * multiplier;
	newVal = getValidTime(newVal);
	if (oldVal === newVal) return;
	breakTime.textContent = newVal;

	emitControlTimerChange("break", newVal);
});
eventDispatcher.on('break-timer:--', function () {
	var multiplier = arguments.length <= 0 || arguments[0] === undefined ? 1 : arguments[0];

	var oldVal = parseInt(breakTime.textContent, 10);
	var newVal = oldVal - 1 * multiplier;
	newVal = getValidTime(newVal);
	if (oldVal === newVal) return;
	breakTime.textContent = newVal;

	emitControlTimerChange("break", newVal);
});
eventDispatcher.on('break-timer:set', function (minutes) {
	if (parseInt(breakTime.textContent, 10) === minutes) return;
	breakTime.textContent = minutes;

	emitControlTimerChange("break", minutes);
});

// store user settings between sessions

function parseStoredItem(keyName) {
	return JSON.parse(localStorage[keyName]);
}

function restoreSettings() {
	// .pauseControls
	pauseOnBreakStart.checked = parseStoredItem("check-pause-on-break-start");
	pauseOnWorkStart.checked = parseStoredItem("check-pause-on-work-start");

	// .notificationControls
	if (notifyOnBreak && "Notification" in window && Notification.permission === "granted") {
		// check that .notificationControls weren't removed
		notifyOnBreak.checked = parseStoredItem("notify-break");
		notifyOnWork.checked = parseStoredItem("notify-work");
	}

	// .timingComtrols
	// .workTimer
	workTime.textContent = parseStoredItem("work-timer");

	// .breakTimer
	breakTime.textContent = parseStoredItem("break-timer");

	// .midPanel
	checkVolume.checked = parseStoredItem("check-volume");
	checkClockSeconds.checked = parseStoredItem("check-clock-seconds");
	checkClockFilled.checked = parseStoredItem("check-clock-filled");
	checkProgress.checked = parseStoredItem("check-progress");

	// alarm sound; a string, so don't parse
	var alarmSound = localStorage["alarm-sound"];
	// if alarm-sound exists assign it and set custom values where necessary, otherwise set defaultSound and don't touch the values
	if (alarmSound) {
		audio.src = alarmSound;
		setCustomSoundValues();
	}

	volumeSlider.value = audio.volume = parseStoredItem("alarm-volume");
}

// update localStorage on settings changes
// .pauseControls
eventDispatcher.on('check-pause-on-break-start:changed', function (val) {
	localStorage["check-pause-on-break-start"] = val;
});
eventDispatcher.on('check-pause-on-work-start:changed', function (val) {
	localStorage["check-pause-on-work-start"] = val;
});

// .notificationControls
eventDispatcher.on('notify-break:changed', function (val) {
	localStorage["notify-break"] = val;
});
eventDispatcher.on('notify-work:changed', function (val) {
	localStorage["notify-work"] = val;
});

// .timingComtrols
// .workTimer
eventDispatcher.on('work-timer:time-set', function (val) {
	localStorage["work-timer"] = val / 60;
});

// .breakTimer
eventDispatcher.on('break-timer:time-set', function (val) {
	localStorage["break-timer"] = val / 60;
});

// .midPanel
eventDispatcher.on('check-volume:changed', function (val) {
	localStorage["check-volume"] = val;
});
eventDispatcher.on('check-clock-seconds:changed', function (val) {
	localStorage["check-clock-seconds"] = val;
});
eventDispatcher.on('check-clock-filled:changed', function (val) {
	localStorage["check-clock-filled"] = val;
});
eventDispatcher.on('check-progress:changed', function (val) {
	localStorage["check-progress"] = val;
});

// alarm sound
eventDispatcher.on('alarm-sound:set', function (sound) {
	localStorage["alarm-sound"] = sound;
});
eventDispatcher.on('alarm-sound:reset', function () {
	delete localStorage["alarm-sound"];
});
eventDispatcher.on('alarm-volume:set', function (val) {
	localStorage["alarm-volume"] = val;
});

// populate localStorage on initial start
function saveInitSettings() {
	// .pauseControls
	eventDispatcher.emit('check-pause-on-break-start:changed', pauseOnBreakStart.checked);
	eventDispatcher.emit('check-pause-on-work-start:changed', pauseOnWorkStart.checked);

	// .notificationControls
	if (notifyOnBreak) {
		// check that .notificationControls weren't removed
		eventDispatcher.emit('notify-break:changed', notifyOnBreak.checked);
		eventDispatcher.emit('notify-work:changed', notifyOnWork.checked);
	}

	// .timingComtrols
	// .workTimer
	eventDispatcher.emit("work-timer:time-set", parseInt(workTime.textContent, 10) * 60);

	// .breakTimer
	eventDispatcher.emit("break-timer:time-set", parseInt(breakTime.textContent, 10) * 60);

	// .midPanel
	eventDispatcher.emit('check-volume:changed', checkVolume.checked);
	eventDispatcher.emit('check-clock-seconds:changed', checkClockSeconds.checked);
	eventDispatcher.emit('check-clock-filled:changed', checkClockFilled.checked, true);
	eventDispatcher.emit('check-progress:changed', checkProgress.checked);

	// alarm volume
	eventDispatcher.emit("alarm-volume:set", audio.volume);
}

// when all resources are loaded and event listeners connected, try to restore settings
window.addEventListener('DOMContentLoaded', function () {
	console.log("DOM LOADED");
	if (localStorage.getItem("check-pause-on-break-start")) {
		try {
			restoreSettings();
		} catch (e) {
			console.log("JSON parsing Error", e);
		}
	}
	document.querySelector(".wrapper").classList.remove("transparent");
	saveInitSettings();
});

// .midPanel input[type="checkbox"]

var checkVolume = document.getElementById("check-volume");
var checkClockSeconds = document.getElementById("check-clock-seconds");
var checkClockFilled = document.getElementById("check-clock-filled");
var checkProgress = document.getElementById("check-progress");

checkVolume.onchange = function () {
	return console.log('changed');
};
checkVolume.oninput = function () {
	return console.log('input');
};

checkVolume.addEventListener('change', function () {
	eventDispatcher.emit('check-volume:changed', this.checked);
});

checkClockSeconds.addEventListener('change', function () {
	eventDispatcher.emit('check-clock-seconds:changed', this.checked);
});

checkClockFilled.addEventListener('change', function () {
	eventDispatcher.emit('check-clock-filled:changed', this.checked);
});

checkProgress.addEventListener('change', function () {
	eventDispatcher.emit('check-progress:changed', this.checked);
});

// .timingControls > button#skipSession

var skipSessionBtn = document.getElementById('skipSession');

skipSessionBtn.addEventListener('click', function () {
	eventDispatcher.emit("skip-session-button-clicked");
});

var ArcMask = function () {
	function ArcMask(element) {
		var startX = arguments.length <= 1 || arguments[1] === undefined ? 50 : arguments[1];
		var startY = arguments.length <= 2 || arguments[2] === undefined ? 0 : arguments[2];
		var radius = arguments.length <= 3 || arguments[3] === undefined ? 50 : arguments[3];

		_classCallCheck(this, ArcMask);

		this._element = element;
		this._startX = startX;
		this._startY = startY;
		this._radius = radius;

		this._dl = "M" + startX + "," + startY + " a" + radius + "," + radius + " 0";
	}

	_createClass(ArcMask, [{
		key: "_getNewCoord",
		value: function _getNewCoord(percent) {
			var theta = 2 * Math.PI * percent / 100,
			    r = this._radius;
			return { x: r * Math.sin(theta), y: r * (1 - Math.cos(theta)) };
		}
	}, {
		key: "drawArc",
		value: function drawArc(percent) {
			percent = 100 - percent;
			var dm = void 0;
			var dr = percent === 100 || percent === 0 ? '' : "L50,50 z";
			if (percent <= 50) {
				dm = '1,0';
				if (percent === 0) percent = .01;
			} else {
				dm = '0,0 ';
			}

			var coord = this._getNewCoord(percent);

			this._element.setAttribute('d', this._dl + " " + dm + " " + coord.x + "," + coord.y + " " + dr);
		}
	}]);

	return ArcMask;
}();

// .progress > progress#totalProgressBar

var prgBar = document.getElementById('totalProgressBar');

eventDispatcher.on('check-progress:changed', function (on) {
	prgBar.classList.toggle('progress-off', !on);
});

// .svgSpace mask > path#arcMask, .progress > progress#totalProgressBar

var arcMask = new ArcMask(document.getElementById('arcMask'));

eventDispatcher.on('timer:session-in-progress', function (_ref6) {
	var _ref6$session = _ref6.session;
	var name = _ref6$session.name;
	var secondsLeft = _ref6$session.left;
	var secondsTotal = _ref6$session.len;

	var percentLeft = Math.round(secondsLeft / secondsTotal * 100);
	console.log("percent left", percentLeft);
	arcMask.drawArc(percentLeft);
	prgBar.value = 100 - percentLeft;
});

eventDispatcher.on('timer:session-modified', function (_ref7) {
	var _ref7$modification = _ref7.modification;
	var valueName = _ref7$modification.valueName;
	var seconds = _ref7$modification.newValue;
	var isCurrentSession = _ref7.isCurrentSession;

	// reset progress indicators when session is modified by the user
	if (valueName === "len" && isCurrentSession) {
		arcMask.drawArc(100);
		prgBar.value = 0;
	}
});

/**
 * Timer with several sessions in order passed to constructor, capable of dispatching events during countdown and between sessions.
 *
 * @param  options  {updateFrequency : 1, loop: true, pauseOnSessionStart: false, pauseOnSessionEnd: false, eventDispatcher: new EventDispatcher}
	* @param updateFrequency	frequency to call _decrement at on current session, in seconds
	* @param loop	whether to loop to first session upon reaching the end or not
	* @param eventDispatcher	an instance of EventDispatcher class, will be ceated if no existing EventDispatcher is passed
	* @param pauseOnSessionStart	whether to pause when changing to a new session (right after _onSessionProgress is fired, left === len)
	* @param pauseOnSessionEnd	whether to pause when currentSession has elapsed (right after _onSessionProgress is fired, left === 0)
	* @param reversed	go through sessions array in reverse
 * @param  sessions array of {name: 'work', len: 25}
	* @param name	name of the session
	* @param len	length of the session in seconds
 */

var Timer = function (_EventfulClass) {
	_inherits(Timer, _EventfulClass);

	// default values in destructuring assignments don't work in Firefox yet
	// constructor({updateFrequency = 1, loop = true, pauseOnSessionStart: false, pauseOnSessionEnd: false, reversed: false, eventDispatcher = new EventDispatcher()}, ...sessions)

	function Timer(options) {
		_classCallCheck(this, Timer);

		var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Timer).call(this, options.eventDispatcher));

		var defaultOptions = { updateFrequency: 1, loop: true, pauseOnSessionStart: false, pauseOnSessionEnd: false, reversed: false };

		var _Object$assign = Object.assign({}, defaultOptions, options);

		_this._updateFrequency = _Object$assign.updateFrequency;
		_this._loop = _Object$assign.loop;
		_this._pauseOnSessionStart = _Object$assign.pauseOnSessionStart;
		_this._pauseOnSessionEnd = _Object$assign.pauseOnSessionEnd;
		_this._reversed = _Object$assign.reversed;


		_this._state = "idle";

		// session = {name: 'break', len: 5[seconds] [, skip: false, pauseOnStart: false, pauseOnEnd: false]}

		for (var _len2 = arguments.length, sessions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
			sessions[_key2 - 1] = arguments[_key2];
		}

		_this._sessions = sessions;
		var startIndex = _this._reversed ? _this._sessions.length - 1 : 0;
		_this._currentSession = sessions[startIndex];
		_this._currentSessionIndex = startIndex;

		_this._sessionsByName = {};

		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = sessions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var session = _step.value;

				Timer.checkTimeValidity(session.len);
				_this._sessionsByName[session.name] = session;
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		return _this;
	}

	_createClass(Timer, [{
		key: "isIdle",
		value: function isIdle() {
			return this._state === "idle";
		}
	}, {
		key: "isActive",
		value: function isActive() {
			return this._state === "active";
		}
	}, {
		key: "isPaused",
		value: function isPaused() {
			return this._state === "paused";
		}
	}, {
		key: "addSession",
		value: function addSession(session) {
			var index = arguments.length <= 1 || arguments[1] === undefined ? this._sessions.length : arguments[1];

			Timer.checkTimeValidity(session.len);
			this._sessions.splice(index, 0, session);
			this._sessionsByName[session.name] = session;

			// hotswap sessions if adding in place of currentSession
			var isCurrentSession = this._currentSessionIndex === index;
			if (isCurrentSession) {
				this._currentSession = session;

				// if countdown is in progress or paused, reset .left on the new session unless already provided
				if (this.isActive() || this.isPaused()) this._resetCurrentSessionIfElapsed();
			}

			this._onSessionModified(session, { valueName: "new-session" }, isCurrentSession);
		}
	}, {
		key: "getElapsedSessions",
		value: function getElapsedSessions() {
			return this._sessions.filter(function (session) {
				return session.left === 0;
			});
		}
	}, {
		key: "getSession",
		value: function getSession(name) {
			return this._sessionsByName[name];
		}
	}, {
		key: "getSessionIndex",
		value: function getSessionIndex(name) {
			var session = this.getSession(name);
			// no session return -1 index
			if (!session) return -1;

			return this._sessions.indexOf(session);
		}
	}, {
		key: "getSessionByIndex",
		value: function getSessionByIndex(index) {
			return this._sessions[index];
		}
	}, {
		key: "setLength",
		value: function setLength(seconds) {
			var name = arguments.length <= 1 || arguments[1] === undefined ? this._currentSession.name : arguments[1];
			var resetCurrentSession = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

			Timer.checkTimeValidity(seconds);
			var settingSession = this._sessionsByName[name];
			if (!settingSession) return;

			var modification = { valueName: "len", oldValue: settingSession.len, newValue: seconds };
			settingSession.len = seconds;

			var isCurrentSession = settingSession === this._currentSession;
			if (isCurrentSession && resetCurrentSession) this.resetCurrentSession();

			// first inform of modification
			this._onSessionModified(settingSession, modification, isCurrentSession);
			// then skip if necessary
			if (seconds === 0 && isCurrentSession) this._sessionTransition();
		}
	}, {
		key: "setTimeLeft",
		value: function setTimeLeft(seconds) {
			var name = arguments.length <= 1 || arguments[1] === undefined ? this._currentSession.name : arguments[1];

			Timer.checkTimeValidity(seconds);
			var settingSession = this._sessionsByName[name];
			if (!settingSession) return;

			var modification = { valueName: "left", oldValue: settingSession.left, newValue: seconds };
			settingSession.left = seconds;

			var isCurrentSession = settingSession === this._currentSession;

			// first inform of modification
			this._onSessionModified(settingSession, modification, isCurrentSession);
			// then skip if necessary
			if (seconds === 0 && isCurrentSession) this._sessionTransition();
		}
	}, {
		key: "setSessionToSkip",
		value: function setSessionToSkip() {
			var skip = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
			var name = arguments.length <= 1 || arguments[1] === undefined ? this._currentSession.name : arguments[1];

			var settingSession = this._sessionsByName[name];
			if (!settingSession) return;

			var modification = { valueName: "skip", oldValue: settingSession.skip, newValue: skip };
			settingSession.skip = skip;

			var isCurrentSession = settingSession === this._currentSession;

			// first inform of modification
			this._onSessionModified(settingSession, modification, isCurrentSession);
			// then skip if necessary
			if (skip && isCurrentSession) this._sessionTransition();
		}
	}, {
		key: "setSessionToPauseOnStart",
		value: function setSessionToPauseOnStart() {
			var pause = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
			var name = arguments.length <= 1 || arguments[1] === undefined ? this._currentSession.name : arguments[1];

			var settingSession = this._sessionsByName[name];
			if (!settingSession) return;

			var modification = { valueName: "pauseOnStart", oldValue: settingSession.pauseOnStart, newValue: pause };
			settingSession.pauseOnStart = pause;

			var isCurrentSession = settingSession === this._currentSession;

			// first inform of modification
			this._onSessionModified(settingSession, modification, isCurrentSession);
		}
	}, {
		key: "setSessionToPauseOnEnd",
		value: function setSessionToPauseOnEnd() {
			var pause = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
			var name = arguments.length <= 1 || arguments[1] === undefined ? this._currentSession.name : arguments[1];

			var settingSession = this._sessionsByName[name];
			if (!settingSession) return;

			var modification = { valueName: "pauseOnEnd", oldValue: settingSession.pauseOnEnd, newValue: pause };
			settingSession.pauseOnEnd = pause;

			var isCurrentSession = settingSession === this._currentSession;

			// first inform of modification
			this._onSessionModified(settingSession, modification, isCurrentSession);
		}
	}, {
		key: "start",
		value: function start() {
			var reason = arguments.length <= 0 || arguments[0] === undefined ? "called-from-without" : arguments[0];

			// pause in case active
			this._pause();
			this.reset();
			this.resume(reason);
		}
	}, {
		key: "startFromSession",
		value: function startFromSession(name) {
			var reason = arguments.length <= 1 || arguments[1] === undefined ? "called-from-without" : arguments[1];

			// pause in case active
			this._pause();

			var session = this.getSession(name);
			if (!session) return;

			this._currentSession = session;
			this._currentSessionIndex = this._sessions.indexOf(session);
			this.resetCurrentSession();
			this.resume(reason);
		}
	}, {
		key: "stop",
		value: function stop() {
			var reason = arguments.length <= 0 || arguments[0] === undefined ? "called-from-without" : arguments[0];

			var prevState = this._state;
			this._pause();
			this.resetOrder();
			this._state = "idle";

			this._onStateChanged(prevState, reason);
		}
	}, {
		key: "pause",
		value: function pause() {
			var reason = arguments.length <= 0 || arguments[0] === undefined ? "called-from-without" : arguments[0];

			var prevState = this._state;
			this._pause();
			this._state = "paused";

			this._onStateChanged(prevState, reason);
		}
	}, {
		key: "_pause",
		value: function _pause() {
			clearInterval(this.intervalId);
		}
	}, {
		key: "resume",
		value: function resume() {
			var reason = arguments.length <= 0 || arguments[0] === undefined ? "called-from-without" : arguments[0];

			// if session is null (when all sessions elapsed and loop === false)
			if (!this._currentSession) return;

			var prevState = this._state;
			this._resume();
			this._state = "active";

			this._onStateChanged(prevState, reason);
		}
	}, {
		key: "_resume",
		value: function _resume() {
			// first report current/starting progress
			this._onSessionProgress();
			this.intervalId = setInterval(this._decrement.bind(this), this._updateFrequency * 1000); //updateFrequency is in seconds
		}
	}, {
		key: "reset",
		value: function reset() {
			this.resetOrder();
			this.resetCurrentSession();
		}
	}, {
		key: "resetOrder",
		value: function resetOrder() {
			var startIndex = this._reversed ? this._sessions.length - 1 : 0;
			this._currentSession = this._sessions[startIndex];
			this._currentSessionIndex = startIndex;
		}
	}, {
		key: "resetCurrentSession",
		value: function resetCurrentSession() {
			// don't manipulate a null session
			if (!this._currentSession) return;
			this._currentSession.left = this._currentSession.len;
		}
	}, {
		key: "_resetCurrentSessionIfElapsed",
		value: function _resetCurrentSessionIfElapsed() {
			// don't reset if session.left was set to something else (by the user)
			var left = this._currentSession.left;
			if (left === undefined || left <= 0) this.resetCurrentSession();
		}
	}, {
		key: "_decrement",
		value: function _decrement() {
			// if starting with no seconds left, which can happen if session was paused-on-end
			if (this._currentSession.left <= 0) this._sessionTransition();

			this._currentSession.left -= this._updateFrequency;
			console.log("left", this._currentSession.left, ", freq", this._updateFrequency);

			// don't actually let it go below 0
			if (this._currentSession.left < 0) this._currentSession.left = 0;

			this._onSessionProgress();

			// if timer elapsed
			if (this._currentSession.left === 0) {
				// pause if required to at the end of session in progress
				if (this._pauseOnEndIfRequired()) return;
				this._sessionTransition();
			}
		}
	}, {
		key: "_sessionTransition",
		value: function _sessionTransition() {
			this._goToNextSession("previous-session-ended");

			// if no next session for whatever reason
			if (this._currentSession == null) this.stop("no-next-session");
			// otherwise reset countdown
			else {
					this._resetCurrentSessionIfElapsed();
					// first report current/starting progress
					this._onSessionProgress();
					// pause if required at the start of new session
					this._pauseOnStartIfRequired();
				}
		}
	}, {
		key: "_goToNextSession",
		value: function _goToNextSession(reason) {
			var prevSession = { session: this._currentSession, index: this._currentSessionIndex };

			var _getNextSession2 = this._getNextSession();

			this._currentSessionIndex = _getNextSession2.index;
			this._currentSession = _getNextSession2.session;

			if (this._currentSession) this._resetCurrentSessionIfElapsed();
			this._onSessionChanged(prevSession, reason);
		}
	}, {
		key: "_getNextSession",
		value: function _getNextSession() {
			var nextSessionIndex = this._currentSessionIndex;

			var nextSession = void 0;

			// look for the next non-skipped session in order of this.session
			do {
				this._reversed ? --nextSessionIndex : ++nextSessionIndex;
				// reached last session, loop to start
				if (nextSessionIndex === this._sessions.length || nextSessionIndex === -1) {
					nextSessionIndex = this._reversed ? this._sessions.length - 1 : 0;

					// unless loop option is false
					if (!this._loop) {
						nextSession = null;
						break;
					}
				}

				// looped already to where started, no available sessions found
				if (nextSessionIndex === this._currentSessionIndex) {
					nextSessionIndex = this._reversed ? this._sessions.length - 1 : 0;
					nextSession = null;
					break;
				}

				nextSession = this._sessions[nextSessionIndex];
			} while (nextSession.skip);

			return { index: nextSessionIndex, session: nextSession };
		}
	}, {
		key: "skipToNextSession",
		value: function skipToNextSession() {
			var thenPause = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
			var resetCurrent = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

			this._skipSession(thenPause, resetCurrent, "skipped-to-next-session");
		}
	}, {
		key: "_skipSession",
		value: function _skipSession(thenPause, resetCurrent, reason) {
			// reset, then skip
			if (resetCurrent) this.resetCurrentSession();
			this._goToNextSession(reason);
			this.resetCurrentSession();

			// if no next session for whatever reason
			if (this._currentSession == null) return this.stop("no-next-session");

			this._onSessionProgress();

			if (thenPause) this.pause("paused-on-start");
		}
	}, {
		key: "skipToPreviousSession",
		value: function skipToPreviousSession() {
			var thenPause = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
			var resetCurrent = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

			// reverse direction
			this._reversed = !this._reversed;

			this._skipSession(thenPause, resetCurrent, "skipped-to-previous-session");

			// restore direction
			this._reversed = !this._reversed;
		}
	}, {
		key: "_pauseOnStartIfRequired",
		value: function _pauseOnStartIfRequired() {
			var paused = this._pauseOnSessionStart || this._currentSession.pauseOnStart;
			if (paused) this.pause("paused-on-start");

			return paused;
		}
	}, {
		key: "_pauseOnEndIfRequired",
		value: function _pauseOnEndIfRequired() {
			var paused = this.pauseOnSessionEnd || this._currentSession.pauseOnEnd;
			if (paused) this.pause("paused-on-end");

			return paused;
		}
	}, {
		key: "_onStateChanged",
		value: function _onStateChanged(previousState, reason) {
			console.log("timer:state-changed", this._currentSession.name, previousState, "=>", this._state);
			this.emit("timer:state-changed", { previousState: previousState, currentState: this._state, session: this._currentSession, index: this._currentSessionIndex, reason: reason });
		}
	}, {
		key: "_onSessionChanged",
		value: function _onSessionChanged(ended, reason) {
			console.log('timer:session-changed', ended.session, ended.index, "=>", this._currentSession, this._currentSessionIndex);
			this.emit('timer:session-changed', { ended: ended, started: { session: this._currentSession, index: this._currentSessionIndex }, reason: reason });
		}
	}, {
		key: "_onSessionProgress",
		value: function _onSessionProgress() {
			console.log("timer:session-in-progress", this._currentSession.name, this._currentSession.left);
			this.emit("timer:session-in-progress", { session: this._currentSession, index: this._currentSessionIndex });
		}

		// fired on setting len, left, skip values or adding a new session via instance methods (not directly through inst.sessions[0].len = ...)

	}, {
		key: "_onSessionModified",
		value: function _onSessionModified(session, modification, isCurrentSession) {
			//  modification is of form {valueName: "new-session"} or {valueName: "[value name], oldValue: [number], newValue: [number]"}
			console.log("session", session.name, "modified", modification, ", isCurrentSession", isCurrentSession);
			this.emit("timer:session-modified", { session: session, modification: modification, isCurrentSession: isCurrentSession, timerState: this.state });
		}

		// fired on setting updateFrequency and loop values

	}, {
		key: "_onOptionsModified",
		value: function _onOptionsModified(modification) {
			//  modification is of form {valueName: "[value name], oldValue: [number], newValue: [number]"}
			console.log("timer:options-modified", modification, this.state);
			this.emit("timer:options-modified", { modification: modification, timerState: this.state });
		}
	}, {
		key: "sessions",
		get: function get() {
			return this._sessions;
		},
		set: function set(sessions) {
			// remove references to current sessions
			this._sessionsByName = {};
			this._sessions = sessions;
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = sessions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var session = _step2.value;

					Timer.checkTimeValidity(session.len);
					this._sessionsByName[session.name] = session;
				}

				// reset progress and order
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			this._pause();
			this.reset();

			this._onSessionModified(sessions, { valueName: "new-sessions" });
		}
	}, {
		key: "state",
		get: function get() {
			return this._state;
		}
	}, {
		key: "sessionsCount",
		get: function get() {
			return this._sessions.length;
		}
	}, {
		key: "currentSession",
		get: function get() {
			return this._currentSession;
		}
	}, {
		key: "currentSessionIndex",
		get: function get() {
			return this._currentSessionIndex;
		}
	}, {
		key: "updateFrequency",
		get: function get() {
			return this._updateFrequency;
		},
		set: function set(freq) {
			Timer.checkTimeValidity(freq);
			var modification = { valueName: "updateFrequency", oldValue: this._updateFrequency, newValue: freq };
			this._updateFrequency = freq;

			this._onOptionsModified(modification);
			// restart interval timer with new frequency if in progress
			if (this.isActive()) {
				this._pause();
				this._resume();
			}
		}
	}, {
		key: "loop",
		get: function get() {
			return this._loop;
		},
		set: function set(loop) {
			var modification = { valueName: "loop", oldValue: this._loop, newValue: loop };
			this._loop = loop;

			this._onOptionsModified(modification);
		}
	}, {
		key: "reversed",
		get: function get() {
			return this._reversed;
		},
		set: function set(reversed) {
			var modification = { valueName: "reversed", oldValue: this._reversed, newValue: reversed };
			this._reversed = reversed;

			this._onOptionsModified(modification);
		}
	}, {
		key: "pauseOnSessionStart",
		get: function get() {
			return this._pauseOnSessionStart;
		},
		set: function set(pause) {
			var modification = { valueName: "pauseOnSessionStart", oldValue: this._pauseOnSessionStart, newValue: pause };
			this._pauseOnSessionStart = pause;

			this._onOptionsModified(modification);
		}
	}, {
		key: "pauseOnSessionEnd",
		get: function get() {
			return this._pauseOnSessionEnd;
		},
		set: function set(pause) {
			var modification = { valueName: "pauseOnSessionEnd", oldValue: this._pauseOnSessionEnd, newValue: pause };
			this._pauseOnSessionEnd = pause;

			this._onOptionsModified(modification);
		}
	}], [{
		key: "checkTimeValidity",
		value: function checkTimeValidity(seconds) {
			if (seconds < 0 || typeof seconds !== "number") throw new RangeError("time must be a positive number");
		}
	}]);

	return Timer;
}(EventfulClass);

var pomodoroTimer = new Timer({ eventDispatcher: eventDispatcher }, { name: "work", len: getWorkTimeSetting() * 60 }, { name: "break", len: getBreakTimeSetting() * 60 });

eventDispatcher.on('work-timer:time-set', function (seconds) {
	pomodoroTimer.setLength(seconds, "work", true);
});
eventDispatcher.on('break-timer:time-set', function (seconds) {
	pomodoroTimer.setLength(seconds, "break", true);
});

eventDispatcher.on('tomato-big-button-clicked', function () {
	switch (pomodoroTimer.state) {
		case "idle":
			pomodoroTimer.start();
			break;
		case "active":
			pomodoroTimer.pause();
			break;
		case "paused":
			pomodoroTimer.resume();
			break;
		default:
			return;
	}
});

eventDispatcher.on('check-pause-on-break-start:changed', function (on) {
	pomodoroTimer.setSessionToPauseOnStart(on, "break");
});
eventDispatcher.on('check-pause-on-work-start:changed', function (on) {
	pomodoroTimer.setSessionToPauseOnStart(on, "work");
});

eventDispatcher.on('skip-session-button-clicked', function (on) {
	pomodoroTimer.skipToNextSession(true);
});

// .tomatoTimer > .svgSpace #minutesSvg

var minutesSvg = document.getElementById('minutesSvg');

var minutesSvgValue = minutesSvg.textContent;

minutesSvg.addEventListener('transitionend', function () {
	this.textContent = minutesSvgValue;
	this.classList.remove('changing');
});

function cancelTransition() {
	minutesSvg.classList.remove('changing');
	minutesSvg.classList.add('no-transition');
}

function changeMinuteSvg(h, m, changeNow, newSessionStarted) {

	var hAndMin = h >= 1 ? h + ":" + (m < 10 ? "0" + m : m) : m;

	if (minutesSvgValue !== hAndMin) {
		minutesSvgValue = hAndMin;
	}

	if (newSessionStarted) {
		minutesSvg.textContent = minutesSvgValue;
	}
	console.log("changeNow", changeNow);

	if (changeNow) {
		// turn transitions back on
		minutesSvg.classList.remove('no-transition');
		// start transition
		minutesSvg.classList.add('changing');
	}
}

function setImmediateMinuteSvg(h, m) {
	var hAndMin = h >= 1 ? h + ":" + (m < 10 ? "0" + m : m) : m;
	// cancel transition in progress if any
	cancelTransition();

	minutesSvgValue = hAndMin;
	minutesSvg.textContent = hAndMin;
}

// .tomatoTimer > .svgSpace #secondsLeft, .tomatoTimer > .seconds

var secondsLeftCircle = document.getElementById('secondsLeft');

var r = parseInt(secondsLeftCircle.getAttribute("r"), 10);
var fct = Math.round(r * 6.285714286) / 100;

// proper offset to draw 60 cells, 1 cell representing 1 second
function changeCircleDashOffset(secondsLeft) {
	var dashoffset = 100 - secondsLeft * 5 / 3;
	console.log("circle secs", secondsLeft, ", dashoffset", dashoffset);
	secondsLeftCircle.style["stroke-dashoffset"] = -fct * dashoffset;
}

var secondsLeftText = document.getElementById('secondsLeftText');

eventDispatcher.on('check-clock-seconds:changed', function (on) {
	secondsLeftCircle.classList.toggle('invisible', !on);
});

function setSecondsDisplay(seconds) {
	// show full circle for *min:00sec exvept for 0min:00sec
	changeCircleDashOffset(seconds === 0 ? 60 : seconds);
	// :01 format instead of :1
	if (seconds < 10) seconds = "0" + seconds;
	secondsLeftText.textContent = ":" + seconds;
}

// #minutesSvg, #secondsLeft, .tomatoTimer > .seconds

function secondsToHMinSec(seconds) {
	var h = Math.floor(seconds / 3600);
	var m = Math.floor(seconds % 3600 / 60);
	var s = Math.floor(seconds % 3600 % 60);

	return { h: h, m: m, s: s };
}

eventDispatcher.on('timer:session-modified', function (_ref8) {
	var _ref8$modification = _ref8.modification;
	var valueName = _ref8$modification.valueName;
	var seconds = _ref8$modification.newValue;
	var isCurrentSession = _ref8.isCurrentSession;

	// only processes modifications for values of len of currenSession
	if (valueName !== "len" || !isCurrentSession) return;

	var _secondsToHMinSec = secondsToHMinSec(seconds);

	var h = _secondsToHMinSec.h;
	var m = _secondsToHMinSec.m;
	var s = _secondsToHMinSec.s;


	setImmediateMinuteSvg(h, m);
	console.log("setting hAndMin", h, m, ", sec", s);
	setSecondsDisplay(s);
});

eventDispatcher.on('timer:session-in-progress', function (_ref9) {
	var _ref9$session = _ref9.session;
	var name = _ref9$session.name;
	var seconds = _ref9$session.left;
	var secondsTotal = _ref9$session.len;

	console.log("received seconds", seconds);

	var _secondsToHMinSec2 = secondsToHMinSec(seconds);

	var h = _secondsToHMinSec2.h;
	var m = _secondsToHMinSec2.m;
	var s = _secondsToHMinSec2.s;


	changeMinuteSvg(h, m, s === 0, seconds === secondsTotal);
	console.log("setting hAndMin", h, m, ", sec", s);
	setSecondsDisplay(s);
});

// .tomatoTimer > .seconds and .tomatoTimer > .session

var sessionText = document.getElementById('sessionName');

eventDispatcher.on('timer:session-changed', function (_ref10) {
	var _ref10$started$sessio = _ref10.started.session;
	var sessionName = _ref10$started$sessio.name;
	var seconds = _ref10$started$sessio.len;

	sessionText.textContent = sessionName;

	// change page title to reflect current session
	document.title = sessionName === "work" ? "Work Time" : "Break Time";
});

var pausedStateText = document.getElementById('pausedState');

eventDispatcher.on('timer:state-changed', function (_ref11) {
	var currentState = _ref11.currentState;
	var sessionName = _ref11.session.name;
	var reason = _ref11.reason;

	var paused = currentState === "paused";

	if (paused && reason === "paused-on-start") {
		console.log("paused-on-start");
		// cancel transition in progress if any
		cancelTransition();
	}

	pausedStateText.classList.toggle("hidden", !paused);

	// reflect paused state in the page title
	var title = sessionName === "work" ? "Work Time" : "Break Time";
	if (paused) title += " : Paused";
	document.title = title;
});

// otherwise transition replays after the fact as soon as focus returns to the page/tab
document.addEventListener("visibilitychange", function () {
	console.log(document.visibilityState, minutesSvg.classList.contains('changing'));
	if (document.visibilityState === "visible") {
		var _secondsToHMinSec3 = secondsToHMinSec(pomodoroTimer.currentSession.left == null ? pomodoroTimer.currentSession.len : pomodoroTimer.currentSession.left);

		var h = _secondsToHMinSec3.h;
		var m = _secondsToHMinSec3.m;

		console.log("After visibility change, HM", h, m);
		setImmediateMinuteSvg(h, m);
	}
});

// .tomatTimer > .svgSpace .all-tomato

var tomatoSvg = document.querySelector('.all-tomato');

eventDispatcher.on('check-clock-filled:changed', function (on, skipTransition) {
	if (skipTransition) {
		// force reflow if necessary
		if (on !== tomatoSvg.classList.contains('transparent')) return;
		tomatoSvg.classList.add("no-transition");
		tomatoSvg.classList.toggle('transparent', !on);
		// reflow
		tomatoSvg.clientWidth;
		tomatoSvg.classList.remove("no-transition");
	} else tomatoSvg.classList.toggle('transparent', !on);
});

// .tomatoTimer

var tomatoTimerBigButton = document.querySelector('.tomatoTimer');

tomatoTimerBigButton.addEventListener('click', function () {
	eventDispatcher.emit("tomato-big-button-clicked");
});
}());
